import { procurementAPI } from "../../axios";

export const actions = {
    // ItemRequest
    CreateItemRequest(context, data){
        return procurementAPI.post(`ItemRequest?deliveryUnitId=${data.deliveryUnitId}`, data);
    },
    GetSingleItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/${data}`);
    },
    UpdateItemRequest(context, data){
        return procurementAPI.put(`ItemRequest/${data.id}`, data);
    },
    RemoveItemRequest(context, data){
        return procurementAPI.delete(`ItemRequest/${data}`);
    },
    GetDUPendingItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Pending/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetDUApprovedItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Approved/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetDUReturnedItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Returned/DeliveryUnit/${data}`);
    },
    GetTechnicalPendingItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Technical/Pending`);
    },
    GetTechnicalApproveItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Technical/Approved`);
    },
    GetCampusPendingItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Pending/Campus/${data}`);
    },
    GetCampusApprovedItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Approved/Campus/${data}`);
    },
    ApproveItemRequest(context, data){
        return procurementAPI.put(`ItemRequest/Approve/${data}`);
    },
    ReturnItemRequest(context, data){
        return procurementAPI.put(`ItemRequest/Return/${data.id}`, data);
    },
    PostItemRequest(context, data){
        return procurementAPI.post(`ItemRequest/Post/${data}`);
    },
    GetDepartmentPendingItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Pending/Department/${data.departmentId}/${data.cycle}`);
    },
    GetDepartmentApprovedItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Approved/Department/${data.departmentId}/${data.cycle}`);
    },
    GetDepartmentReturnedItemRequest(context, data){
        return procurementAPI.get(`ItemRequest/Returned/Department/${data}`);
    },
}